'use client'

import React, { Component } from 'react'
import { Card, CardContent } from '@/shared/components/ui/card'
import { Button } from '@/shared/components/ui/button'
import { RefreshCw } from 'lucide-react'

type PreTripErrorBoundaryProps = { children: React.ReactNode }
type PreTripErrorBoundaryState = { hasError: boolean }

export class PreTripErrorBoundary extends Component<
  PreTripErrorBoundaryProps,
  PreTripErrorBoundaryState
> {
  constructor(props: PreTripErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  render() {
    if (this.state.hasError) {
      return (
        <Card className="border-amber-200 bg-amber-50 dark:border-amber-900 dark:bg-amber-950/30">
          <CardContent className="pt-6">
            <p className="text-sm font-medium text-amber-800 dark:text-amber-200">
              Something went wrong displaying the document. Your upload succeeded — refresh the page
              to see it.
            </p>
            <Button
              variant="outline"
              size="sm"
              className="mt-3"
              onClick={() => window.location.reload()}
            >
              <RefreshCw className="h-4 w-4 mr-1.5" />
              Refresh page
            </Button>
          </CardContent>
        </Card>
      )
    }
    return this.props.children
  }
}
